var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var NumberComponent = /** @class */ (function (_super) {
    __extends(NumberComponent, _super);
    function NumberComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    NumberComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var options = (this.col.params && this.col.params.options ? this.col.params.options : {});
        if (typeof options.min !== 'undefined') {
            this.min = options.min;
        }
        if (typeof options.max !== 'undefined') {
            this.max = options.max;
        }
    };
    NumberComponent.prototype.onChange = function (e) {
        if (typeof this.min !== 'undefined' && this.min > e) {
            this.val = this.min;
        }
        else if (typeof this.max !== 'undefined' && this.max < e) {
            this.val = this.max;
        }
        _super.prototype.onChange.call(this, this.val);
    };
    NumberComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-number',
                    template: '<input type="number" name="{{ colKey }}" attr.name="{{ colKey }}" [placeholder]="col" min="{{ min }}" max="{{ max }}" [(ngModel)]="val" (change)="onChange(val)" [key]="key" [col]="col" columnDir>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    NumberComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return NumberComponent;
}(ColumnBaseComponent));
export { NumberComponent };
//# sourceMappingURL=number.component.js.map